import React, {Component} from 'react';
import '../../../../styles/Home.css'
import '../../../../styles/Miesieczne.css'
import Panel from "../../Panel";
import {Link} from "react-router-dom";

export default class PomyslnieMiesieczny extends Component {

    render() {
        return <Panel>
            <div className="text-center" style={{paddingTop: 25, background: 'white'}}>
                <h2><i className="fa fa-2x fa-check" style={{marginRight: '40px', color: '#8dc846'}}> </i> <b>Karta została założona pomyślnie</b></h2>
                <h5 style={{fontWeight: 400, marginTop: 25}}>Karta zostanie aktywowana po weryfikacji przez pracownika.</h5>
                <hr/>
                <h6 style={{fontWeight: 400}}>Aby sprawdzić status lub opłacić kartę przejdź do <Link to={'/konto/bilety/miesieczne'}>biletów miesięcznych</Link>.</h6>
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/PomyslnieMiesieczny.js